module.exports = __webpack_public_path__ + "img/41_help-counsellor.d2656bf2.jpg";